<template>
  <div class="account_setting_wrap">
    <Header></Header>
    <div class="account_setting_main">
      <div class="account_setting_menu">
        <div class="account_setting_menu_box" :style="{width:!isOpen?'0px':'140px'}">
          <ul>
            <li v-for="(item,index) in routerLink" :key="index" :class="{active : index===curId}" @click="tabSwitch(item,index)">{{item.name}}</li>
          </ul>
        </div>
        <img src="../../../../static/images/course/close.png" alt="" v-if="isOpen" class="switchImg close" @click="isOpen=false">
        <img src="../../../../static/images/course/open.png" alt="" v-else class="switchImg open" @click="isOpen=true">
      </div>
      <div class="account_setting_content" :style="isOpen?'width: calc(100% - 140px)':'width: 100%'">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
  import Header from '../../header/header'
  import '@/views/szrt_revision/new_account_settings/css/accountSet.scss'
  import Zlicon from "../../../views/szrt_revision/new_account_settings/accountSettings/zlicon";
  export default {
    components: {
      Header
    },
    data() {
      return {
        isOpen: true,
        curId: 0,
        routerLink:[],
        routerPath:''
      }
    },
    created(){
      sessionStorage.removeItem('prodName')
      this.routerLink = [
        { name: '个人信息', path: '/settings/personalInformation' },
        { name: '修改密码', path: '/settings/changePassword' },
        { name: '安全设置', path: '/settings/securitySetting' },
        // { name: '资源统计', path: '/settings/resourceStatistic' },
      ]
      this.routerPath = this.routerLink[0].path
      // if (this.showByDeptId()){  // 指定机构有权限
      //
      // }

      if (sessionStorage.getItem('userType') < 2){ //0管理员，1老师
        this.routerLink.push({ name: '资源统计', path: '/settings/resourceStatistic' })
      }
      // if (sessionStorage.getItem('userType') !== '0'){ //0管理员
      this.routerLink.push({ name: '数据统计', path: '/settings/overallStatistics' })
      // }
      // this.routerLink.push( { name: '中联图标库', path: '/settings/zlicon' })
    },
    watch: {
      '$route':{
        handler(to, from){
          this.$nextTick(()=>this.setCurId())
          if(to.path=="/settings"){
            this.$router.push({path:this.routerPath})
          }
        },
        immediate: true
      }
    },
    methods:{
      tabSwitch(item,i){
        this.$router.push(item.path)
      },
      setCurId(){
        this.curId = this.routerLink.findIndex(item=>item.path === this.$route.path)
      },
      // showByDeptId(){
      //   let deptId = sessionStorage.getItem('deptId');
      //   let showList = [
      //     6344, 4553, 6008, 6009, 6010, 6011, 6012, 6013, 6014, 6015, 6016, 6017,
      //     6018, 6019, 6020, 6021, 6022, 6023, 6024, 6025, 6026, 6027, 6028, 6029,
      //     6030, 6031, 6032, 6033, 6034, 6035, 6036, 6037, 310, 380, 445, 1, 409,
      //     286, 543, 119, 6353, 1329, 1601, 1194, 8626, 1279, 1410, 1359, 1559,
      //     7810, 1738, 1305, 1229, 4855, 4808, 8751, 1801, 1603, 11,
      //   ];
      //   return showList.indexOf(Number(deptId)) > -1
      // },
    }
  }
</script>


<style lang="scss">
  .account_setting_wrap{
    width: 100%;
    height: 100%;
    background: #F6F8FB;
    .account_setting_main{
      height: calc(100% - 64px);
      display: flex;
      justify-content: space-between;
      overflow: auto;
      .account_setting_menu{
        height: 100%;
        background: #fff;
        position: relative;
        .account_setting_menu_box{
          width: 140px;
          overflow: hidden;
          transition: .4s all;
        }
        .account_setting_menu_title{
          height: 40px;
          display: flex;
          align-items: center;
          border-bottom: 1px solid #5397F7;
          img{
            height: 14px;
            margin: 0 10px 0 15px;
          }
          span{
            font-size:12px;
            font-weight:normal;
            line-height: 40px;
            color:#5397F7;
          }
        }
        ul{
          li{
            width:115px;
            height:32px;
            background:#fff;
            border-radius:4px;
            margin: 10px;
            font-size:12px;
            font-weight:normal;
            color:#5D646E;
            padding-left: 33px;
            box-sizing: border-box;
            position: relative;
            line-height: 32px;
            cursor: pointer;
            &:hover{
              background: #F6F8FB;
              color:#5D646E;
              &::after{
                background: #99A0AA;
              }
            }
            &::after{
              position: absolute;
              left: 15px;
              top: 15px;
              content: '';
              width: 3px;
              height: 3px;
              background: #99A0AA;
              border-radius: 50%;
            }
          }
          .active{
            background: #5397F7 !important;
            color: #fff !important;
            &::after{
              background: #fff !important;
            }
          }
        }
        .switchImg{
          width: 16px;
          position: absolute;
          right: -16px;
          top: 0;
          bottom: 0;
          margin: auto;
          cursor: pointer;
        }
      }
      .account_setting_content{
        min-width: 1226px;
        height: 100%;
        margin-left: 16px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/accountSettings/accountSettings.vue